export enum AccountType {
    Dealer = "Dealer",
    Internal = "Internal",
    Customer = "Customer",
    Other = "Other",
}
